import React from 'react';
const { useState, useEffect } = React;
import { CURRENT_USER } from '../../globals.js';
import { chargesCall } from '../../chargesClient.js';
import { CHARGE } from '../../billingSchema.js';
import { planGroupOf } from '../../charges.js';
import { payerOfCharge, samePayer, cents, money } from '../../payments.js';
import { fmt } from './ChargesList.jsx';
import { openQuoteFile } from './QuoteList.jsx';

// «Pagos y saldos» on a person's card (Contactos, Personas) or a company's tab: what this payer still owes
// (per currency) and, for each contratación or charge without a quote with a balance, the way to its file,
// where payments are registered (the same file from every access). Only this payer's charges: a company never
// sees the personal charges of the people who work there, nor the other way round. The administration only
// (charges.mts checks it on every call); for anyone else this renders nothing.
const openCharge = (chargeId) => window.dispatchEvent(new CustomEvent('oike:navigate', { detail: { page: 'quotes', chargeId } }));

export default function PayerPayments({ payer, name = '', intakes = [] }) {
  const [billing, setBilling] = useState(null);
  const [allowed, setAllowed] = useState(CURRENT_USER?.role === 'admin' || !!globalThis.window?.__OIKE_DEMO__); // the demo has no login; the server checks anyway
  useEffect(() => { if (allowed && payer?.id) chargesCall('list').then(setBilling).catch(() => setAllowed(false)); }, [payer?.id]);
  if (!allowed || !payer?.id || !billing) return null;
  const mine = billing.charges.filter(c => c.fields?.[CHARGE.status] === 'open' && samePayer(payerOfCharge(c.fields || {}), payer) && (c.state?.pending || 0) > 0);
  const byCur = {};
  for (const c of mine) byCur[c.state.currency] = (byCur[c.state.currency] || 0) + cents(c.state.pending);
  // One row per contratación (its quote) or per charge without a quote (its plan)
  const groups = new Map();
  for (const c of mine) {
    const quote = (c.fields?.[CHARGE.quote] || [])[0];
    const k = planGroupOf(c, billing.charges);
    const g = groups.get(k) || { quote, chargeId: c.id, title: quote ? (intakes.find(r => r.id === quote)?.fields?.['Name'] || 'Contratación') : (c.fields?.[CHARGE.concept] || 'Cobro sin cotización'), byCur: {} };
    g.byCur[c.state.currency] = (g.byCur[c.state.currency] || 0) + cents(c.state.pending);
    groups.set(k, g);
  }
  return (
    <div style={{ padding: '10px 12px', borderRadius: 8, marginBottom: 10, border: '1px solid var(--globant-border)' }} aria-label="Pagos y saldos">
      <div style={{ fontSize: 13, fontWeight: 700 }}>Pagos y saldos</div>
      <div style={{ fontSize: 12, color: 'var(--globant-muted)', marginTop: 2 }}>
        {Object.keys(byCur).length ? `Saldo por cobrar: ${Object.entries(byCur).map(([cur, c]) => fmt(money(c), cur)).join(' · ')}. Los pagos se registran en la ficha de cada una.` : `Sin saldos pendientes${name ? ` de ${name}` : ''}.`}
      </div>
      {[...groups.values()].map(g => (
        <div key={g.quote || g.chargeId} style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', fontSize: 12, marginTop: 6 }}>
          <span style={{ flex: '1 1 180px' }}>{g.quote ? 'Contratación' : 'Cobro sin cotización'}: <b>{g.title}</b></span>
          <span>{Object.entries(g.byCur).map(([cur, c]) => fmt(money(c), cur)).join(' · ')}</span>
          <button type="button" className="action-btn btn-ghost" style={{ fontSize: 11 }} onClick={() => (g.quote ? openQuoteFile(g.quote) : openCharge(g.chargeId))}>Abrir ficha</button>
        </div>
      ))}
    </div>
  );
}
